import Login from '@/views/Login/Login';
import Unauthorized from '@/views/Login/Unauthorized';
import Postbacks from '@/views/Logs/Postbacks';
import Reports from '@/views/Reports/Reports';
import Users from '@/views/Users/Users';
import Volunteers from '@/views/Volunteers/Volunteers';
import axios from 'axios';
import Vue from 'vue';
import Router from 'vue-router';
import { GumshoeUser } from './models';

Vue.use(Router);
const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      meta: {
        title: 'Error Logs',
        icon: 'person_pin',
        display: false
      },
      component: Login
    },
    {
      path: '/access-denied',
      name: 'AccessDenied',
      meta: {
        title: 'Error Logs',
        icon: 'person_pin',
        display: false
      },
      component: Unauthorized
    },
    {
      path: '/',
      name: 'BackgroundCheckReportsDefault',
      meta: {
        title: 'Sleuth Reports',
        icon: 'bar_chart',
        display: false,
        roles: ['admin', 'csr']
      },
      component: Reports
    },

    {
      path: '/reports',
      name: 'BackgroundCheckReports',
      meta: {
        title: 'Sleuth Reports',
        icon: 'bar_chart',
        display: true,
        roles: ['admin', 'csr']
      },
      component: Reports
    },
    {
      path: '/volunteers',
      name: 'Volunteer',
      meta: {
        title: 'Verification Lookup',
        icon: 'person_pin',
        display: true,
        roles: ['admin', 'csr']
      },
      component: Volunteers
    },
    {
      path: '/webhookLogs',
      name: 'WebHookLogs',
      meta: {
        title: 'Webhook Logs',
        icon: 'person_pin',
        display: true,
        roles: ['admin']
      },
      component: Postbacks
    }
  ]
});

router.beforeResolve((to, _, next) => {
  if (to.path.startsWith('/login')) {
    if (location.hostname === 'localhost' || location.hostname === 'localhost') {
      next();
    } else {
      next(false);
      window.location.href = '/login';
    }

    return;
  }

  if (!!localStorage.getItem('currentUser') &&
      !!JSON.parse(localStorage.getItem('currentUser')).authed) {
    next();
  } else {
    axios.get('/self')
    .then(x => {
      if (x.status !== 200) {
        next('/login');
      } else {
        const user = new GumshoeUser(undefined, x.data.data);
        localStorage.setItem('currentUser', JSON.stringify(user));
        next();
      }
    })
    .catch(() => next('/login'));
  }
});

export default router;
